<template>
    <div class="board" v-if="formData && errorLookup">
        <div class="bar">
            <b-icon icon="card-text" class="icon"></b-icon>
            <span>เลขที่อ้างอิงการจอง</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เลขที่อ้างอิงการจอง</label>
                            <input type="text"
                                    v-model="formData.booking.refNumber"
                                    class="input-field"
                                    :class="{ 'invalid': errorLookup.refNumber.blank }"
                                    readonly
                                    placeholder="หมายเลขการจอง" />
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4" v-if="isShowButtonBookingRef">
                        <div class="field">
                            <label class="no-label">-</label>
                            <button class="btn btn-red" @click="openLookupBookingRef()">ค้นหาหมายเลขการจอง</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <job-modal-online-lookup :isDisplay="isShowLookupOnlineBooking" @hide="closeLookupBookingRef($event)"></job-modal-online-lookup>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import JobModalOnlineLookup from '@/components/job/order/ModalOnlineLookup';

export default {
    mixins:  [ MixinThemeBoard ],
    components: {
        JobModalOnlineLookup
    },
    data() {
        return {
            isShowButtonBookingRef: true,
            isShowLookupOnlineBooking: false,
            formData: null,
            errorLookup: null
        }
    },
    props: {
        jobState: Number,
        loadData: Object
    },
    mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);
            this.errorLookup = this.initValidateLookup();

            if (this.loadData) {
                if (this.loadData.status !== this.$Constants.JOB_STATUS_NEW) {
                    this.initPendingDisplay();
                }
            }
        },
        initForm() {
            return {
                booking: {
                    refNumber: this.loadData ? this.loadData.booking.refNumber : ''
                }
            };
        },
        initValidateLookup() {
            return {
                refNumber: { blank: false }
            };
        },
        initPendingDisplay() {
            this.isShowButtonBookingRef = false;

            this.$emit('bookingRefReady', null);
        },
        openLookupBookingRef() {
            this.isShowLookupOnlineBooking = true;
        },
        closeLookupBookingRef(data) {
            if (data) {
                this.formData.booking.refNumber = data.reserve.bookingId;

                this.$emit('bookingRefReady', data);
            }

            this.isShowLookupOnlineBooking = false;
        }
    }
}
</script>